import { Decimal } from 'decimal.js';

export const getValueFromPercent = (percent: number, total: number): number => {
  // Calculate the amount from the percentage.
  // Round the value to the nearest 4 fraction digits using the ROUND_HALF_EVEN (Bankers rounding) algorithm.
  return new Decimal((percent * total) / 100)
    .toDecimalPlaces(4, Decimal.ROUND_HALF_EVEN)
    .toNumber();
};
